import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import AquasecConfigListing from './AquasecConfigListing'
import AquasecCredentialsForm from './AquasecCredentialsForm'

export default function AquasecPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={AquasecCredentialsForm}
            PullConfigListingView={AquasecConfigListing}
            RunOnDemandButtonText={'Sync tool images'}
        />
    )
}
